
import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 15,
    hours: 8,
    minutes: 45,
    seconds: 30
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20loft%20insulation%20installation%20worker%20in%20protective%20gear%20installing%20high-quality%20insulation%20materials%20in%20a%20clean%20modern%20attic%20space%20with%20wooden%20beams%20and%20proper%20lighting%2C%20showing%20energy%20efficiency%20improvement%20work%20in%20progress%2C%20clean%20white%20background%2C%20professional%20photography%20style&width=1440&height=800&seq=hero-bg&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-gray-900/40"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Your Loft Insulation Solution
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Bringing Energy Efficiency to Your Home: Professional Loft Insulation, Boarding & Spray Foam Removal in Coventry
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button size="lg" className="text-lg px-8 py-4">
              Get Your Free Estimate
            </Button>
            <button 
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white border-2 border-white/30 rounded-lg hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            >
              <i className="ri-play-circle-line mr-2 text-xl"></i>
              Talk to Expert
            </button>
          </div>

          {/* Special Offer Voucher */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 max-w-md relative overflow-hidden">
            <div className="absolute top-0 right-0 w-20 h-20 bg-emerald-500 rounded-full -mr-10 -mt-10"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 bg-emerald-200 rounded-full -ml-8 -mb-8"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <div className="text-3xl font-bold text-emerald-600">£500 OFF</div>
                  <div className="text-gray-700">On Your Complete<br />Loft Insulation Project</div>
                </div>
                <div className="text-right text-sm text-gray-600">
                  <div className="font-bold text-lg">{timeLeft.days} days</div>
                  <div className="font-mono">{String(timeLeft.hours).padStart(2, '0')}h:{String(timeLeft.minutes).padStart(2, '0')}m:{String(timeLeft.seconds).padStart(2, '0')}s</div>
                  <div>Valid only in<br />January 2025</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Badges */}
      <div className="absolute bottom-8 left-0 right-0">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-4xl">
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className="ri-shield-check-line text-emerald-600 text-xl"></i>
              </div>
              <div className="text-sm font-medium text-gray-800">
                <strong>10-year</strong> warranty
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className="ri-leaf-line text-emerald-600 text-xl"></i>
              </div>
              <div className="text-sm font-medium text-gray-800">
                <strong>Eco</strong><br />friendly
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className="ri-map-pin-line text-emerald-600 text-xl"></i>
              </div>
              <div className="text-sm font-medium text-gray-800">
                Local to<br /><strong>Coventry</strong>
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className="ri-time-line text-emerald-600 text-xl"></i>
              </div>
              <div className="text-sm font-medium text-gray-800">
                <strong>Same day</strong> quotes
              </div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className="ri-tools-line text-emerald-600 text-xl"></i>
              </div>
              <div className="text-sm font-medium text-gray-800">
                <strong>Professional</strong> installation
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
